import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, CardActions, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Tooltip, Chip, Divider, Select, Modal, Box, InputLabel, Backdrop, CircularProgress, Switch, Dialog, DialogTitle, DialogActions } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, AccountBalanceWalletOutlined, VisibilityOutlined, CloseOutlined, DeleteForever } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    agent_id: string;
    agent_details: any;
    deviceDetails: any;
    anchorEl: any;
    pickupsPageSize: number;
    pickups: any[];
    pickupsStatusFilter: string;
    showLoader: boolean;
    hierarchies: any;
    forceSync: any;
    deviceVerification: any;
    showEditAgent: boolean;
    showEditDeviceDetails: boolean;
    pickupsRowCount: any;
    showDeleteAgentConfirmationDialog: boolean;
}

class AgentDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            agent_id: this.props.match.params.id,
            agent_details: {
                // "id": this.props.match.params.id,
                // "agent_name": "Ketut Astika",
                // "balance": "30,884.00",
                // "mobile": "8199934561",
                // "email": "pratama@gmail.com",
                // "city": "Hyderabad",
                // "agent_level": "Agent",
                // "agent_type": "Payment collection agent",
                // "status": "Active"
            },
            deviceDetails: {
                device_name: '',
                device_id: ''
            },
            anchorEl: null,
            pickupsPageSize: 20,
            pickups: [],
            pickupsStatusFilter: "",
            showLoader: false,
            hierarchies: [],
            forceSync: null,
            deviceVerification: 0,
            showEditAgent: false,
            showEditDeviceDetails: false,
            pickupsRowCount: 0,
            showDeleteAgentConfirmationDialog: false
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });

        this.fetchAccessibleHierarchiesList();
        this.fetchAgentDetails();
        this.fetchPickups();
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let hierarchies: any = [];
            if (response.data.success) {
                response.data.data.map((hierarchy: any) => {
                    hierarchies[hierarchy.id] = hierarchy;
                });
            }
            this.setState({ hierarchies: hierarchies });
        })
    }

    public fetchAgentDetails() {
        this.setState({ showLoader: true });
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds
        }
        axios.get(`getAgentDetails/${this.state.agent_id}`, { params: body }).then((response: any) => {
            if (response.data.success) {
                this.setState({ showLoader: false });
                let data = response.data.data;
                this.setState({
                    agent_details: data,
                    forceSync: (data.agent) ? data.agent.force_sync : 0,
                    deviceVerification: Boolean((data.device) ? data.device.is_active : 0)
                })
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchPickups = (page: any = 0, limit: any = this.state.pickupsPageSize) => {
        this.setState({ showLoader: true });
        let body = {
            "agent_id": this.state.agent_id,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "page": page + 1,
            "limit": limit,
            "pickup_status": (this.state.pickupsStatusFilter != 'all') ? this.state.pickupsStatusFilter : ""
        }
        axios.post('filterPickups', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                let data = response.data.data.data;
                this.setState({ showLoader: false, pickups: data, pickupsRowCount: response.data.data.total });
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const label = { inputProps: { 'aria-label': 'Color switch demo' } };

        const open = Boolean(this.state.anchorEl);

        const handleCustomerMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };

        const handleToggleAgentLevel = () => {
            this.setState({ showLoader: true });
            let body = {
                "agent_id": this.state.agent_id,
                "hierarchies": this.props.user.selectedHierarchyIds,
            }
            axios.post('promoteAgent', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                this.fetchAgentDetails();
            }).catch((error) => {
                this.setState({
                    showLoader: false,
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
        };

        const toggleAgentStatus = (agentId: any, status: any) => {
            this.setState({ showLoader: true });
            let body = {
                "agent_id": agentId,
                "hierarchies": this.props.user.selectedHierarchyIds,
            }
            axios.post('toggleAgentStatus', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                this.setState({ showLoader: false, anchorEl: null });
                toast.success(
                    t("Agent") +
                    (status == 1 ? " Deactivated " : " Activated ") +
                    t("Successfully"),
                    {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    }
                );
                this.fetchAgentDetails();
            }).catch((error) => {
                this.setState({
                    showLoader: false,
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
        }

        const handleSetForceSyncStatus = (event: any) => {
            this.setState({ showLoader: true })
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "agent_id": this.state.agent_id,
                "force_sync": this.state.forceSync
            }
            axios.post('setForceSyncStatus', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showLoader: false });
                    toast.success(this.state.forceSync == true ? t("Agent App In Sync") : t("Agent App Not In Sync"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAgentDetails()
                } else {
                    this.setState({ showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleAgentDeviceVerification = () => {
            this.setState({ showLoader: true })
            let body = {
                "hierarchies": this.props.user.selectedHierarchyIds,
                "agent_id": this.state.agent_id,
                "device_id": (this.state.agent_details.device) ? this.state.agent_details.device.device_id : ""
            }
            axios.post('toggleDeviceVerification', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showLoader: false });
                    toast.success("Agent device Status updated!", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAgentDetails()
                } else {
                    this.setState({ showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const closeCustomerMoreOptions = () => {
            setTimeout(() => {
                this.setState({ anchorEl: null });
            }, 1);
        };

        const handleEditAgent = (details: any) => {
            closeCustomerMoreOptions();
            this.setState({ showEditAgent: true })

        }

        const handleUpdateAgent = () => {
            let body = {
                "name": this.state.agent_details.name,
                "phone": this.state.agent_details.phone,
                "email": this.state.agent_details.email,
                "agent_id": this.state.agent_id,
                "hierarchies": this.props.user.selectedHierarchyIds
            }
            axios.post('agentProfileEdit', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showEditAgent: false });
                    toast.success(t("Agent Updated"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAgentDetails();
                } else {
                    this.setState({ showLoader: false, showEditAgent: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false, showEditAgent: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });

        }

        const handleUpdateDeviceDetails = () => {
            let body = {
                "agent_id": this.state.agent_id,
                "device_name": this.state.deviceDetails.device_name,
                "device_id": this.state.deviceDetails.device_id,
                "hierarchies": this.props.user.selectedHierarchyIds
            }
            axios.post('linkDeviceId', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showEditDeviceDetails: false });
                    toast.success(t("Device Details Updated"), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchAgentDetails();
                } else {
                    this.setState({ showLoader: false, showEditDeviceDetails: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false, showEditDeviceDetails: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const handleDeleteAgent = () => {
            this.setState({ showLoader: true });
            let payload: any = { agent_id: this.state.agent_id };
            axios.post(`deleteAgent`, payload).then(response => {
                if (response.data.success) {
                    this.setState({ showDeleteAgentConfirmationDialog: false, showLoader: false }, () => this.fetchAgentDetails());
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    window.location.replace('/operations/agents');
                } else {
                    this.setState({ showDeleteAgentConfirmationDialog: false, showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showDeleteAgentConfirmationDialog: false, showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const pickupColumns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: "Date",
                field: "pickup_date",
                width: 100
            },
            {
                headerName: "Slot",
                field: "pickup_slot",
                width: 100
            },
            {
                headerName: "Payment",
                field: "payment_status",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.payment_status == 'complete') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.payment_status == 'complete' ? "Complete" : "Pending"}</Typography>
                )
            },
            {
                headerName: "Status",
                field: "pickup_status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.pickup_status == 'complete') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.pickup_status == 'complete' ? "Complete" : "Pending"}</Typography>
                )
            },
            {
                headerName: "Action",
                field: "action",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Button type='button' size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => {
                        this.props.history.push('/operations/batch-pickups/group-pickups/pickup-details/' + params.id)
                    }}><VisibilityOutlined /></Button>
                )
            }
        ];



        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-2">
                        <Card>
                            <CardHeader
                                avatar={
                                    <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/operations/agents'}><KeyboardArrowLeftRounded /></Button>
                                }
                                title="Agent Details"
                                className="text-left"
                                action={
                                    <IconButton aria-label="customer-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleCustomerMoreOptions(e)}>
                                        <MoreHorizOutlined id="customer-more-options-button" sx={{ outline: 'none !important' }} />
                                        <Menu
                                            id="customer-more-options-menu"
                                            aria-labelledby="customer-more-options-button"
                                            anchorEl={this.state.anchorEl}
                                            open={open}
                                            onClose={() => closeCustomerMoreOptions()}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                        >
                                            <MenuItem className='customMenuItem' onClick={() => handleEditAgent(this.state.agent_details)}>{t("Edit Agent Details")}</MenuItem>
                                            <MenuItem className='customMenuItem' onClick={() => toggleAgentStatus(this.state.agent_id, this.state.agent_details?.is_active)}>{(this.state.agent_details?.is_active == 1) ? 'Deactivate' : 'Activate'} {t("Agent")}</MenuItem>

                                        </Menu>
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails" sx={{ minHeight: '320px', boxShadow: 3 }}>
                                            <CardHeader title="Basic Details" className='text-left' />
                                            <CardContent className='overview'>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Agent ID
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.agent_details.id}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Name
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.agent_details.name}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Phone
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.agent_details.phone}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Email
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.agent_details.email}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        City
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {
                                                            this.state.agent_details.hierarchies &&
                                                            this.state.agent_details.hierarchies.map((city: any) => {
                                                                return <Chip key={city.id} label={city.info.name} sx={{ marginLeft: '5px' }} />
                                                            })
                                                        }
                                                    </Grid>
                                                    {/* <Grid item md={6} xs={6} className='detailsTitle'>
                                                        City
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.agent_details.city}
                                                    </Grid> */}
                                                    <Grid item md={4} xs={4} className='detailsTitle'>
                                                        Status
                                                    </Grid>
                                                    <Grid item md={8} xs={8} className='detailsValue'>
                                                        <Typography className={(this.state.agent_details.is_active == 1) ? 'statusTextSuccess' : 'statusTextError'}>{this.state.agent_details.is_active == 1 ? "Active" : "Inactive"}</Typography>
                                                    </Grid>
                                                   <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Force Agent App Sync
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        <Switch {...label} checked={this.state.forceSync} name="force_sync" onChange={(e: any) => this.setState({ forceSync: !this.state.forceSync }, () => handleSetForceSyncStatus(e))} size="small" />
                                                    </Grid>
                                                    <Grid item md={4} xs={6} className='detailsTitle'>
                                                        Device Details
                                                    </Grid>
                                                    <Grid item md={8} xs={6} className='detailsValue'>
                                                        <div>{this.state.agent_details.device == null ? "No Name - " : this.state.agent_details.device.device_name + ' - ' + this.state.agent_details.device.device_id}&nbsp;
                                                            <Tooltip title="Update">
                                                                <IconButton
                                                                    color="primary"
                                                                    className="customIconButton"
                                                                    aria-label="Update"
                                                                    component="span"
                                                                    onClick={() => this.setState({
                                                                        showEditDeviceDetails: true,
                                                                        deviceDetails: {
                                                                            device_name: (this.state.agent_details.device) ? this.state.agent_details.device.device_name : '',
                                                                            device_id: (this.state.agent_details.device) ? this.state.agent_details.device.device_id : ''
                                                                        }
                                                                    })}
                                                                    size="small"
                                                                    sx={{ padding: 0 }}
                                                                >
                                                                    <EditOutlined />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Force Device Verification
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        <Switch {...label} checked={Boolean(this.state.deviceVerification)} name="device-verification" onChange={(e: any) => this.setState({ deviceVerification: !this.state.deviceVerification }, () => handleAgentDeviceVerification())} size="small" />
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Permanently Delete
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        <Tooltip title="Delete">
                                                            <IconButton
                                                                color="error"
                                                                aria-label="Delete"
                                                                component="span"
                                                                onClick={() => this.setState({ showDeleteAgentConfirmationDialog: true })}
                                                                size="small"
                                                                sx={{ padding: 0, outline: 'none!important' }}
                                                            >
                                                                <DeleteForever />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title={
                                                    <>
                                                        <Grid container spacing={2}>
                                                            <Grid item md={6} xs={12}>
                                                                <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Pickup History")}</Typography>
                                                            </Grid>

                                                            <Grid item md={6} xs={12}>
                                                                <FormControl fullWidth size="small">
                                                                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                                                    <Select
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        value={this.state.pickupsStatusFilter}
                                                                        label="Age"
                                                                        onChange={(e: any) => this.setState({ pickupsStatusFilter: e.target.value }, () => this.fetchPickups())}
                                                                    >
                                                                        <MenuItem value={'all'}>All</MenuItem>
                                                                        <MenuItem value={'pending'}>Pending</MenuItem>
                                                                        <MenuItem value={'complete'}>Complete</MenuItem>
                                                                        <MenuItem value={'cancelled'}>Cancelled</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </>
                                                }
                                                className="text-left"
                                            />
                                            <CardContent>
                                                <DataGrid
                                                    aria-label="Pickups"
                                                    columns={pickupColumns}
                                                    rows={this.state.pickups}
                                                    rowCount={this.state.pickupsRowCount}
                                                    pageSize={this.state.pickupsPageSize}
                                                    onPageChange={(page) => this.fetchPickups(page)}
                                                    onPageSizeChange={(newPageSize) => this.setState({ pickupsPageSize: newPageSize }, () => this.fetchPickups())}
                                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                                    // autoHeight={true}
                                                    sx={{ height: '375px' }}
                                                    components={{
                                                        MoreActionsIcon: EditOutlined,
                                                    }}
                                                    paginationMode="server"
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                                {/* <Grid container spacing={2} className="mt-2">
                                    <Grid item md={6} xs={12}>
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title="Attendance"
                                                className="text-left"
                                                action={
                                                    <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAttendance: true })}>
                                                        <Add /> Add Attendance
                                                    </Button>
                                                }
                                            />
                                            <CardContent>
                                                <DataGrid
                                                    aria-label="Attendance"
                                                    columns={attendanceColumns}
                                                    rows={this.state.attendance}
                                                    pageSize={this.state.attendancePageSize}
                                                    onPageSizeChange={(newPageSize) => this.setState({ attendancePageSize: newPageSize })}
                                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                                    autoHeight={true}
                                                    components={{
                                                        MoreActionsIcon: EditOutlined,
                                                    }}
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Card sx={{ boxShadow: 3 }}>
                                            <CardHeader
                                                title="Transactions"
                                                className="text-left"
                                                action={
                                                    <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddTransaction: true })}>
                                                        <Add /> Add Transaction
                                                    </Button>
                                                }
                                            />
                                            <CardContent>
                                                <DataGrid
                                                    aria-label="Transactions"
                                                    columns={transactionColumns}
                                                    rows={this.state.transactions}
                                                    pageSize={this.state.transactionsPageSize}
                                                    onPageSizeChange={(newPageSize) => this.setState({ transactionsPageSize: newPageSize })}
                                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                                    autoHeight={true}
                                                    components={{
                                                        MoreActionsIcon: EditOutlined,
                                                    }}
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid> */}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showEditAgent}
                    onClose={() => this.setState({ showEditAgent: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Edit Agent Details"
                                className="text-left"
                                action={
                                    <IconButton
                                        color="primary"
                                        className="customIconButton"
                                        aria-label="upload picture"
                                        component="span"
                                        onClick={() => this.setState({ showEditAgent: false })}
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="customer-name-input"
                                            label={t("Agent Name") + " *"}
                                            value={this.state.agent_details?.name}
                                            onChange={(e: any) =>
                                                this.setState({ agent_details: { ...this.state.agent_details, name: e.target.value } })
                                            }
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="mobile-input"
                                            label={t("Mobile") + " *"}
                                            value={this.state.agent_details?.phone}
                                            onChange={(e: any) =>
                                                this.setState({ agent_details: { ...this.state.agent_details, phone: e.target.value } })
                                            }
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="email-input"
                                            label={t("Email") + " *"}
                                            type={"email"}
                                            value={this.state.agent_details?.email}
                                            onChange={(e: any) =>
                                                this.setState({ agent_details: { ...this.state.agent_details, email: e.target.value } })
                                            }
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider className="mt-3" />
                            </CardContent>
                            <CardActions className="float-right">
                                <Button
                                    size="small"
                                    className="customCloseButton"
                                    onClick={() => this.setState({ showEditAgent: false })}
                                >
                                    {t("Close")}
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    sx={{ outline: "none !important" }}
                                    onClick={() => handleUpdateAgent()}
                                >
                                    {t("Update Agent")}
                                </Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showEditDeviceDetails}
                    onClose={() => this.setState({ showEditDeviceDetails: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Update Device Details"
                                className="text-left"
                                action={
                                    <IconButton
                                        color="primary"
                                        className="customIconButton"
                                        aria-label="upload picture"
                                        component="span"
                                        onClick={() => this.setState({ showEditDeviceDetails: false })}
                                    >
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <TextField
                                            id="customer-name-input"
                                            label={t("Name") + " *"}
                                            value={this.state.deviceDetails?.device_name}
                                            onChange={(e: any) =>
                                                this.setState({ deviceDetails: { ...this.state.deviceDetails, device_name: e.target.value } })
                                            }
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <TextField
                                            id="mobile-input"
                                            label={t("Id") + " *"}
                                            value={this.state.deviceDetails?.device_id}
                                            onChange={(e: any) =>
                                                this.setState({ deviceDetails: { ...this.state.deviceDetails, device_id: e.target.value } })
                                            }
                                            fullWidth={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider className="mt-3" />
                            </CardContent>
                            <CardActions className="float-right">
                                <Button
                                    size="small"
                                    className="customCloseButton"
                                    onClick={() => this.setState({ showEditDeviceDetails: false })}
                                >
                                    {t("Close")}
                                </Button>
                                <Button
                                    size="small"
                                    variant="contained"
                                    sx={{ outline: "none !important" }}
                                    onClick={() => handleUpdateDeviceDetails()}
                                >
                                    {t("Update")}
                                </Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Dialog
                    open={this.state.showDeleteAgentConfirmationDialog}
                    onClose={() => this.setState({ showDeleteAgentConfirmationDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Are you sure you want to delete this agent?"}
                    </DialogTitle>
                    <DialogActions>
                        <Button size="small" className="customCloseButton" onClick={() => this.setState({ showDeleteAgentConfirmationDialog: false })}>Close</Button>
                        <Button size="small" variant="contained" color="error" sx={{ outline: "none !important" }} onClick={() => handleDeleteAgent()} autoFocus>Delete</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(AgentDetails))